"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AE = exports.OE = exports.SLASHED_O = exports.ASH = exports.O_CAUDATA = exports.THORN = exports.ETH = exports.VALID_AS_FIRST = exports.ALPHABET = exports.UPPER_CASE = exports.LOWER_CASE = void 0;
// Case variations.
exports.LOWER_CASE = ['a', 'á', 'b', 'd', 'ð', 'e', 'é', 'f', 'g', 'h', 'i', 'í', 'j', 'k', 'l', 'm', 'n', 'o', 'ó', 'p', 'r', 's', 't', 'u', 'ú', 'v', 'w', 'y', 'ý', 'þ', 'æ', 'ǫ', 'ø', 'œ'];
exports.UPPER_CASE = ['A', 'Á', 'B', 'D', 'Ð', 'E', 'É', 'F', 'G', 'H', 'I', 'Í', 'J', 'K', 'L', 'M', 'N', 'O', 'Ó', 'P', 'R', 'S', 'T', 'U', 'Ú', 'V', 'W', 'Y', 'Ý', 'Þ', 'Æ', 'Ǫ', 'Ø', 'Œ'];
// Combined alphabet.
exports.ALPHABET = __spreadArray(__spreadArray([], exports.LOWER_CASE, true), exports.UPPER_CASE, true);
// Letters valid as first characters of a word.
exports.VALID_AS_FIRST = ['a', 'á', 'b', 'd', 'e', 'é', 'f', 'g', 'h', 'i', 'í', 'j', 'k', 'l', 'm', 'n', 'o', 'ó', 'p', 'r', 's', 't', 'u', 'ú', 'v', 'y', 'ý', 'þ', 'æ', 'ǫ', 'ø', 'œ'];
// "Special" letters.
exports.ETH = 'ð';
exports.THORN = 'þ';
exports.O_CAUDATA = 'ǫ';
exports.ASH = 'æ';
exports.SLASHED_O = 'Ø';
exports.OE = 'œ';
exports.AE = exports.ASH;
exports.default = {
    ALPHABET: exports.ALPHABET,
    LOWER_CASE: exports.LOWER_CASE,
    UPPER_CASE: exports.UPPER_CASE,
    VALID_AS_FIRST: exports.VALID_AS_FIRST,
    ETH: exports.ETH,
    THORN: exports.THORN,
    O_CAUDATA: exports.O_CAUDATA,
    ASH: exports.ASH,
    SLASHED_O: exports.SLASHED_O,
    OE: exports.OE,
    AE: exports.ASH,
};
//# sourceMappingURL=alphabet.js.map